import { jArticleListSchema, jArticleViewSchema } from './article';
import { z } from 'zod';

export const jQuizzListSchema = jArticleListSchema.extend({
    quizzDescription: z.string().nullable(),
    quizzClosingDate: z.string().nullable(),
    dateStart: z.string().nullable(),
    dateEnd: z.string().nullable(),
});
export type jQuizzList = z.infer<typeof jQuizzListSchema>;

export const jQuizzViewSchema = jArticleViewSchema.and(jQuizzListSchema).and(
    z.object({
        quizzInvitation: z.null(),
        quizzFormSpec: z.string(),
        quizzRandom: z.null(),
        quizzHideResponses: z.null(),
        quizzStatus: z.null(),
        quizzPublicationDate: z.string().nullable(),
    }),
);
export type jQuizzView = z.infer<typeof jQuizzViewSchema>;
